import { colors } from "../../colors";
import { CloseIcon } from "../../icons/close";

export function SuccessPopup(props: { message: string, active: boolean, onClose: () => void }) {
    if (!props.active) {
        return null;
    }

    setTimeout(() => props.onClose(), 4000);

    return (
        <div className="gap-[12px] text-left flex flex-row justify-start items-center" style={{ padding: '30px 25px', borderRadius: '12px', backgroundColor: '#D1F5D9', borderColor: '#8AE59F', borderWidth: 2 }}>
            <CloseIcon size={14} color={colors.green[700]} onClick={() => props.onClose()} />
            <span className="text-green-700 fieldsetTitle" style={{ fontSize: '18px', fontWeight: '600', display: 'block' }}>
                {props.message}
            </span>
        </div>
    )
}